// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3zfkO","options":"AnswerScale_options__1QE_e","selected":"AnswerScale_selected__1xU9r"};